export default "__VITE_ASSET__25e50079__"